<h1 style="font-size: 5em;">
  <countdown #cd [config]="{leftTime: timer, demand: true, format: 'HH:mm:ss'}"></countdown>
</h1>
